import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addModeOfPayment = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_mode_of_payment',
    // '/api/method/technoerp.services.upsert_mode_of_payment',
    '/api/resource/Mode of Payment',
    body
  );
  return data;
});

export const updateModeOfPayment = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    // `/api/method/technoerp.services.update_mode_of_payment`,
    // `/api/method/technoerp.services.upsert_mode_of_payment/${id}`,
    `/api/resource/Mode of Payment/${id}`,
    body
  );
  return data;
});

export const getModeOfPayments = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    // '/api/method/technoerp.services.get_mode_of_payments'
    `/api/resource/Mode of Payment?fields=["name","enabled","type"]`
  );
  return data;
});

export const getModeOfPaymentById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/resource/Mode of Payment/${id}`
    `/api/resource/Mode of Payment/${id}`
  );
  return data;
});
export const deleteModeOfPayment = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_record?record=${record}&document=Mode of Payment`
    `/api/resource/Mode of Payment/${record}`
  );
  return data;
});
